import React, { ReactElement } from 'react';
import { NavigationButtons } from '../../shared/NavigationButtons';
import { Form, Formik } from 'formik';
import {
  CoverageCheckupState,
  goToNextStep,
  updateCoverageCheckupState,
} from '../../../store/step';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '../../../store/store';
import { InsuranceDetailsForm } from '../../shared/InsuranceDetailsForm';
import { createInsuranceDetailsSchema } from '../../schema/InsuranceDetailsSchema';
import { CardPadding } from '../../shared/CardStyles';
import { CardHeader } from '../../shared/CardStyles/CardHeader';
import { useFormInteractionTracking } from '../../../hooks/useFormInteractionTracking';

function LifeInsuranceDetailsStep(): ReactElement {
  const dispatch = useDispatch();
  const { lifeInsuranceLastReviewed: lifeInsuranceLastReviewed } = useSelector(
    (state: RootState) => state.steps
  );

  const formRef = useFormInteractionTracking('last_checked_life_ins');

  function onSubmit(values: Partial<CoverageCheckupState>): void {
    dispatch(updateCoverageCheckupState(values));
    dispatch(goToNextStep());
  }
  return (
    <CardPadding>
      <CardHeader
        header="When was the last time you looked over your life insurance rates or
          coverage details?"
      />

      <Formik
        initialValues={{ lifeInsuranceLastReviewed }}
        onSubmit={onSubmit}
        validationSchema={createInsuranceDetailsSchema(
          'lifeInsuranceLastReviewed'
        )}
      >
        <Form ref={formRef}>
          <InsuranceDetailsForm name="lifeInsuranceLastReviewed" />
          <NavigationButtons />
        </Form>
      </Formik>
    </CardPadding>
  );
}

export { LifeInsuranceDetailsStep };
